import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestSstComponent } from './pages/request-sst/request-sst.component';
import { TypeServiceProvideComponent } from './components/type-service-provide/type-service-provide.component';
import { LaborDataComponent } from './components/labor-data/labor-data.component';
import { AttachmentsComponent } from './components/attachments/attachments.component';
import { SharedModule } from "../../shared/shared.module";
import { ReactiveFormsModule,FormsModule } from "@angular/forms";
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { RenewalComponent } from './components/renewal/renewal.component';
import { ModificationComponent } from './components/modification/modification.component';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { ResumeRequestSavedComponent } from './components/resume-request-saved/resume-request-saved.component';
import { DemoNgZorroAntdModule } from "../../core/modules/ng-antd.module";
import { PdfViewerModule } from 'ng2-pdf-viewer';

import {MatTableModule} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {EditInfoComponent} from "./components/edit-info/edit-info.component";

@NgModule({
  declarations: [
    RequestSstComponent,
    TypeServiceProvideComponent,
    LaborDataComponent,
    AttachmentsComponent,
    UserDashboardComponent,
    RenewalComponent,
    ModificationComponent,
    ResumeRequestSavedComponent,
    EditInfoComponent,
  ],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        DemoNgZorroAntdModule,
        PdfViewerModule,
        FormsModule,
        MatTableModule,
        NgxPaginationModule,
        NgbModule,
        MatPaginatorModule,
        MatSortModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  exports: [
    ModificationComponent,
    RenewalComponent,
    LaborDataComponent,
    TypeServiceProvideComponent
  ]
})
export class RequestModule {
}
